var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#3C73FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6901 18.06C18.5064 18.2258 18.2676 18.3176 18.0201 18.3176C17.7726 18.3176 17.5339 18.2258 17.3501 18.06L8.87012 10.35C9.20287 10.1221 9.59678 10.0001 10.0001 10H26.0001C26.4035 10.0001 26.7974 10.1221 27.1301 10.35L18.6901 18.06Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2598V22.9998C28 23.7954 27.6839 24.5585 27.1213 25.1211C26.5587 25.6837 25.7956 25.9998 25 25.9998H11C10.2044 25.9998 9.44129 25.6837 8.87868 25.1211C8.31607 24.5585 8 23.7954 8 22.9998V12.2598L16.68 20.1798C17.0461 20.4977 17.5152 20.6718 18 20.6698C18.4909 20.6688 18.9643 20.4872 19.33 20.1598L28 12.2598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.676430e434baef656c34287fc8e43457.svg";
export { ForwardRef as ReactComponent };